import React from 'react';
import { Avatar, SxProps, Theme } from '@mui/material';
import { getAvatarColorFromName, getInitials, ownerAvatarColor, ownerInitials } from '../../helpers/general.helpers';

interface UserAvatarProps {
  src?: string | null;
  firstname?: string | null;
  lastname?: string | null;
  /** Full name string — used when separate firstname/lastname are not available. */
  name?: string | null;
  userId?: number;
  size?: number;
  fontSize?: string;
  /** Additional MUI sx overrides merged on top of the base styles. */
  sx?: SxProps<Theme>;
}

const FALLBACK_BG = '#9e9e9e';

export function UserAvatar({
  src,
  firstname,
  lastname,
  name,
  userId,
  size = 32,
  fontSize = '0.7rem',
  sx,
}: UserAvatarProps) {
  let bgcolor: string;
  let initials: string;

  if (firstname != null || lastname != null) {
    bgcolor = userId !== undefined ? ownerAvatarColor(userId) : FALLBACK_BG;
    initials = ownerInitials({ firstname, lastname });
  } else if (name) {
    bgcolor = userId !== undefined ? ownerAvatarColor(userId) : getAvatarColorFromName(name);
    initials = getInitials(name);
  } else {
    bgcolor = FALLBACK_BG;
    initials = '?';
  }

  return (
    <Avatar
      src={src ?? undefined}
      sx={{
        width: size,
        height: size,
        fontSize,
        fontWeight: 700,
        bgcolor,
        flexShrink: 0,
        ...sx,
      }}
    >
      {initials}
    </Avatar>
  );
}
